var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEnergyPurchased(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 77 77",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n        stroke: #62797e;\n        stroke-width: 4px;\n      }\n\n      .cls-1, .cls-2 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-3 {\n        fill: #324e55;\n      }\n\n      .cls-2 {\n        fill: none;\n        stroke: #0eaa82;\n        stroke-linecap: round;\n        stroke-width: 5px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M6.3,35.5s-4,26.4,16.1,35.2c24.4,10.7,39.8-10.3,39.8-10.3"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 38.5,
    cy: 38.4,
    r: 30.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M48.2,31.7s-.2-7.5-9-7.5-10.2,5.9-10.2,5.9c0,0-1,2.7,1.5,5.2s9.4,4.2,11.3,4.7c1.9.5,3.9,1,5.3,3.4s.5,5.2-1.2,7-3.8,2.4-5.7,2.5-6.6.3-9.2-2.1c-2.3-2.1-2.3-4.9-2.3-4.6"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 39.2,
    y1: 24.1,
    x2: 39.2,
    y2: 17.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 38.5,
    y1: 59.8,
    x2: 38.5,
    y2: 52.9
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnergyPurchased);
export default __webpack_public_path__ + "static/media/energyPurchased.166991f9405c1e23461ee40ca7ca57b1.svg";
export { ForwardRef as ReactComponent };